<template>
  <div
    class="cn-search"
    :class="{
      'cn-search--dark': dark,
    }"
  >
    <UiSearchForm
      v-model="searchText"
      :hint="$t('search_hint')"
      :dark="dark"
      initial-focus
      @search="search"
    />
    <div class="cn-search__queries">
      <h2 class="cn-search__queries-title">
        {{ $t('frequent_search_queries') }}
      </h2>
      <p class="cn-search__queries-description">
        {{ $t('click_on_a_search_term') }}
      </p>
      <ul class="cn-search__queries-tags">
        <li v-for="(tag, i) in tags" :key="i">
          <button @click="selectTag(tag)">{{ tag }}</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import UiSearchForm from '@/components/ui/UiSearchForm';

interface Props {
  dark?: boolean;
}

defineProps<Props>();
const emit = defineEmits<{
  (e: 'search'): void;
}>();
const router = useRouter();
const localePath = useLocalePath();

const searchText = ref('');
const tags = ['#canyon', '#contact', '#keyboard'];
const selectTag = (tag) => {
  searchText.value = tag.slice(1);
};
const search = () => {
  if (!searchText.value) return;
  router.push({
    path: localePath('/search/products/'),
    query: { search: searchText.value },
  });
  emit('search');
};
</script>

<style lang="scss">
.cn-search {
  --ab-canyon-search-queries-color-text: var(--ab-canyon-color-primary);
  --ab-canyon-search-term-color-text: var(--ab-canyon-color-neutral-dark);
  --ab-canyon-search-tags-color-text: var(--ab-canyon-color-primary);
  --ab-canyon-search-queries-color-text-dark: var(--ab-canyon-color-light);
  --ab-canyon-search-term-color-text-dark: var(--ab-canyon-color-light);
  --ab-canyon-search-tags-color-text-dark: var(--ab-canyon-color-light);

  &__queries {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  &__queries-title {
    color: var(--ab-canyon-search-queries-color-text);
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  &__queries-description {
    color: var(--ab-canyon-search-term-color-text);
    font-size: 0.875rem;
    line-height: 1.25rem;
    margin-top: var(--size-xs);
  }
  &__queries-tags {
    color: var(--ab-canyon-search-tags-color-text);
    column-gap: var(--size-base);
    align-items: center;
    flex-wrap: wrap;
    display: flex;
    margin-top: var(--size-xl);
  }

  &--dark {
    .cn-search {
      &__search-queries {
        color: var(--ab-canyon-search-queries-color-text-dark);
      }
      &__search-term {
        color: var(--ab-canyon-search-term-color-text-dark);
      }
      &__tags {
        color: var(--ab-canyon-search-tags-color-text-dark);
      }
    }
  }
}
</style>
